import React from 'react'
import Paper from '@mui/material/Paper';
import { Divider } from '@mui/material';
import { Link } from 'react-router-dom';

const Facility = () => {
    return (
        <>
            <div className="col-md-12">
                <Paper elevation={6}>

                    <div className='pb-0'>
                        <div className='text-center p-3 pt-5'>
                            <h2> GENERAL FACILITIES </h2>
                        </div>
                        {/* <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'black' }} /> */}

                        <div className='row p-3'>
                            <div className="col-md-6 p-2">
                                <Paper elevation={6} className='facility-box'>
                                    <div className="">
                                        <div className="text-center p-2 bg-primary text-white">
                                            <b> Library </b>
                                        </div>
                                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'white' }} />
                                        <div className='p-3'>
                                            <div className='row'>
                                                <div className="col-md-9 text-justify">
                                                    The college is provided with a modern Library. It is well stocked with more than 10,000 selected volumes of books and also Journals of National and International standard keeping the students well informed of the latest development in the field of Medical Sciences, as well as in the Nursing field.
                                                </div>
                                                <div className="col-md-3">
                                                    <img src="/assets/facilities/library.jpg" className='col-12' alt="faculty images Library" />
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </Paper>
                            </div>
                            <div className="col-md-6 p-2">
                                <Paper elevation={6} className='facility-box'>
                                    <div className="">
                                        <div className="text-center p-2 bg-primary text-white">
                                            <b> Transportation </b>
                                        </div>
                                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'white' }} />
                                        <div className='p-3'>
                                            <div className='row'>
                                                <div className="col-md-9 text-justify">
                                                    Transportation to and from, from the institution is provided to the students by Society’s own buses. Students are also provided with transportation for Study Tour, Health camps, Workshops , Clinical Postings etc.
                                                </div>
                                                <div className="col-md-3">
                                                    <img src="/assets/facilities/transportation.jpg" className='col-12' alt="faculty images transportation" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Paper>
                            </div>

                            <div className="col-md-6 p-2">
                                <Paper elevation={6} className='facility-box'>
                                    <div className="">
                                        <div className="text-center p-2 bg-primary text-white">
                                            <b> Hostels </b>
                                        </div>
                                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'white' }} />
                                        <div className='p-3'>
                                            <div className='row'>
                                                <div className="col-md-9 text-justify">
                                                General facilities: The Society provides hostels with cozy and homely atmosphere to accommodate students of different courses. The Hostels are under strict supervision of the Management. They cater to the individual taste of the boarders in food and lodging.
                                                </div>
                                                <div className="col-md-3">
                                                    <img src="/assets/facilities/hostel.jpg" className='col-12' alt="faculty images hostelss" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Paper>
                            </div>

                            <div className="col-md-6 p-2">
                                <Paper elevation={6} className='facility-box'>
                                    <div className="">
                                        <div className="text-center p-2 bg-primary text-white">
                                            <b> Extra Curricular </b>
                                        </div>
                                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'white' }} />
                                        <div className='p-3 text-justify'>


                                            <div className='row'>
                                                <div className="col-md-9 text-justify">
                                                    Proper attention is given in exposing and enhancing multi talents of the students in Extra-Curricular fields like Sports, Cultural, Literature etc. through Annual Competitions, Freshers Meet, College Week etc.
                                                </div>
                                                <div className="col-md-3">
                                                    <img src="/assets/facilities/extra.jpg" className='col-12' alt="faculty images curricular" />
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </Paper>
                            </div>


                        </div>

                    </div>



                    {/* <div className='pb-0'>
                        <div className='text-center p-3'>
                            <h2> General Facilities </h2>
                        </div>
                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'black' }} />

                        <div className='row p-3'>
                            <Paper elevation={6} className='facility-box'>
                                <div className="row">
                                    <div className="col-md-6 p-2">
                                        <div className="text-center p-2 bg-primary text-white">
                                            <b> Library </b>
                                        </div>
                                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'white' }} />
                                        <div className='p-3 text-justify'>
                                            The college is provided with a modern Library. It is well stocked with more than 10,000 selected volumes of books and also Journals of National and International standard keeping the students well informed of the latest development in the field of Medical Sciences, as well as in the Nursing field.
                                        </div>
                                    </div>
                                    <div className="col-md-6 p-2">
                                        <div className="text-center p-2 bg-primary text-white">
                                            <b> Transportation </b>
                                        </div>
                                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'white' }} />
                                        <div className='p-3 text-justify'>
                                            Transportation to and fro, from the institution is provided to the students by Society’s own buses. Students are also provided with transportation for Study Tour, Health camps, Workshops etc.
                                        </div>
                                    </div>
                                </div>
                            </Paper>

                        </div>
                        <div className='row p-3'>
                            <Paper elevation={6} className='facility-box'>
                                <div className="row">
                                    <div className="col-md-6 p-2">
                                        <div className="text-center p-2 bg-primary text-white">
                                            <b> Hostels </b>
                                        </div>
                                        <div className='p-3 text-justify'>
                                            The Society provides hostels with cozy and homely atmosphere to accommodate students of different courses. The Hostels are under strict supervision of the Management. They cater to the individual taste of the boarders in food & lodging. Students have to pay the minimum seat-rent for hostel during vacations.
                                        </div>
                                    </div>
                                    <div className="col-md-6 p-2">
                                        <div className="text-center p-2 bg-primary text-white">
                                            <b> Extra Curricular </b>
                                        </div>
                                        <Divider variant="middle" sx={{ borderBottomWidth: 2, borderColor: 'white' }} />
                                        <div className='p-3 text-justify'>
                                            Proper attention is given in exposing and enhancing multi talents of the students in Extra-Curricular fields like Sports, Cultural, Literature etc. through Annual Competitions, Freshers Meet, College Week etc.
                                        </div>
                                    </div>
                                </div>
                            </Paper>

                        </div>
                    </div> */}

                </Paper>
            </div>
        </>
    )
}

export default Facility;